import { ApiReport,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import { smartDownload } from '../../../infra/helper/downloadHelper'
import doFetch from '../../../infra/helper/fetchHelper'
import saveStreamZIP from '../../../infra/helper/saveStreamZIP'


export default (requestid, type, part) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    let filename = requestid + '_' + type;
    if(type == 'detail' && part > 1) {
        filename += '_' + part;
    }

    let data = {
        'request-id':requestid,
        'type':type,
        'part':part
    }

    const Authorization = UserToken;
    const url = ApiReport + 'report-download';
    // const url = 'http://localhost:9191/apireport/report-download';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
            'Content-Type':'application/json',
        },
        body : JSON.stringify(data)
    };

    // Traditional download method as fallback for smaller files
    const traditionalDownload = async (url, argument, filename) => {
        const response = await doFetch(url, argument);
        if(response.ok){
            var responseText = await response.text();
            saveStreamZIP(filename, responseText);
        }
        return response;
    };

    // Simple debugging: Try original method first  
    // console.log('Attempting download with original method first...');
    
    try {
        const response = await doFetch(url, argument);
        // console.log('doFetch response:', response.ok, response.status);
        
        if(response.ok){
            // console.log('Getting response text...');
            var responseText = await response.text();
            // console.log('Response text length:', responseText.length);
            
            // console.log('Calling saveStreamZIP...');
            await saveStreamZIP(`${filename}.zip`, responseText);
            // console.log('saveStreamZIP completed');
        }
        
        dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus: response.ok });
        return response;
    } catch (error) {
        // console.error('Original method failed, trying smart download...', error);
        
        // Fallback to smartDownload if original fails
        try {
            // console.log('Starting smart download process...');
            
            const response = await smartDownload(
                url, 
                argument, 
                `${filename}.zip`,
                {
                    fallbackMethod: traditionalDownload,
                    thresholdMB: 50,
                    progressCallback: (progress) => {
                        // console.log(`Download progress:`, progress);
                    }
                }
            );
            
            // console.log('Smart download response:', response.ok, response.status);
            
            dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus: response.ok });
            return response;
        } catch (smartError) {
            // console.error('Smart download also failed:', smartError);
            dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus: false });
            return { ok: false };
        }
    }
};